import { Order } from '@protos/v2/order';
import { streamV2OrderNotifications } from '@services/context';
import { useEffect, useRef } from 'react';

export type OrderNotificationCallback = (order: Order) => void;

export const useOrderNotifications = (accountIds: string[], callback: OrderNotificationCallback, isReadyToSubscribe: boolean) => {
  const target = useRef<OrderNotificationCallback>(callback);

  useEffect(() => {
    if (!isReadyToSubscribe || !accountIds.length) return;

    target.current = callback;
    accountIds.forEach(accountId => {
      if (accountId) {
        streamV2OrderNotifications.subscribe(accountId, callback);
      }
    });

    return () => {
      accountIds.forEach(accountId => {
        if (accountId) {
          streamV2OrderNotifications.unsubscribe(accountId, callback);
        }
      });
    };
  }, [isReadyToSubscribe, accountIds, callback]);
};
